export type Application = {
  id: string;
  name: string;
  ccname: string;
  ouname: string;
  buname: string;
};

// export const downloadKubeConfig = (tenant: Tenant) => {
//   const filename = `kaap-${tenant.name}.kubeconfig`;
//   const fileContent = tenant.getKubeconfig();
//   download(fileContent, filename);
// };

export const downloadApplicationDetails = (applications: Application[]) => {
  const filename = `kaap-applications-details.jsonc`;
  let fileContent =
    '// For more details go to https://frontstage.tomtomgroup.com/docs/default/component/kaap-documentation\n\n';
  fileContent += JSON.stringify(applications, null, 2);
  download(fileContent, filename);
};

function download(fileContent: string, filename: string) {
  const blob = new Blob([fileContent], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Revoke the object URL after the download to free up memory
  URL.revokeObjectURL(url);
}
